var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:(_vm.text),expression:"text",modifiers:{"right":true}}],staticClass:"page",class:{'is-active': _vm.route === _vm.$route.meta.section},attrs:{"to":{ name: _vm.route },"data-border":_vm.border}},[_c('app-backend-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }